import React from "react";
import { useTranslation } from "react-i18next";

function RiskTrend({ riskHistory, cardStyle }) {
const { t } = useTranslation();

return (

<div style={cardStyle}>

<h3>{t("commandCenter.riskTrend.title")}</h3>

<div
style={{
display: "flex",
flexDirection: "column",
gap: "12px"
}}
>

{riskHistory.map((item, index) => (

<div
key={index}
style={{
display: "flex",
justifyContent: "space-between",
padding: "10px",
borderBottom: "1px solid #1e293b"
}}
>

<div>
<b>{item.time}</b>
</div>

<div
style={{
color:
item.risk === "SAFE"
? "#16a34a"
: item.risk === "WARNING"
? "#f59e0b"
: "#dc2626",
fontWeight: "bold"
}}
>
{t(`commandCenter.risk.${item.risk}`, item.risk)}
</div>

<div>
{item.confidence}%
</div>

</div>

))}

</div>

</div>

);

}

export default RiskTrend;